import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import styles from "../../assets/styles/appointments.module.css"
import { FormGroup, InputAdornment, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { SearchIcon } from '../../utils/functions/Icons';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../utils/store';
import Loader from '../common/Loader';
import NoDataFound from '../common/NoDataFound';
import { getLabPrescriptionListApi } from '../../utils/api/services';
import { useNavigate } from 'react-router-dom';
import ConfirmModal from '../common/ConfirmModal';

export default function UploadedPrescription() {
    const [searchValue, setSearchValue] = useState('')
    const [year, setYear] = useState<string | number>("0");
    const [loading, setLoading] = useState(false)
    const [labTestData, setLabTestData] = useState<UploadedPrescription[] | []>([])
    const [actionValues, setActionValues] = useState<string[]>([]);
    const [particularData, setParticularData] = useState<UploadedPrescription | null>(null);
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const [btnLoading, setBtnLoading] = useState(false);

    const navigate = useNavigate();

    const handleViewReport = (e: React.MouseEvent<HTMLButtonElement>, item: string) => {
        e.stopPropagation();
        window.open(item)
    }

    const CloseConfirmModal = () => {
        setOpenConfirmModal(false);
    };
    const confirmSubmit = async () => {

    }
    const handleAction = (event: SelectChangeEvent<string>, index: number, item: UploadedPrescription) => {
        event.stopPropagation();
        const newActionValues = [...actionValues];
        newActionValues[index] = event.target.value;
        setActionValues(newActionValues);

        if (event.target.value !== '0') {
            setParticularData(item);
            setOpenConfirmModal(true);
        }
    };
    const fetchLabtestApi = async (data: { search: string, filter: string | number }) => {
        try {
            setLoading(true)
            const result = await getLabPrescriptionListApi(data);
            if (result?.success) {
                setLoading(false)
                setLabTestData(result?.prescriptions);
            }
            else {
                setLoading(false)
            }
        } catch (error) {
            setLoading(false)
        }
    }

    useEffect(() => {
        if (searchValue) {
            const cleanFunction = setTimeout(() => {
                fetchLabtestApi({ search: searchValue || '', filter: year });
            }, 1000);
            return () => clearTimeout(cleanFunction);
        } else {
            fetchLabtestApi({ search: searchValue || '', filter: year });
        }
    }, [searchValue, year]);

    return (
        <div>
            <div className={'mb-6 flex justify-between items-center flex-col md:flex-row w-full max-w-full gap-y-4 md:gap-y-0'}>
                <FormGroup className="customFormGroup md:w-1/2 w-full">
                    <TextField
                        className={`custumTextField ${styles.InputStyle}`}
                        id="searchValue"
                        name="searchValue"
                        onChange={(e) => setSearchValue(e.target.value)}
                        value={searchValue}
                        placeholder='search'
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </FormGroup>
                <FormGroup className="customFormGroup md:w-36 w-full">
                    <Select
                        className={`custumTextField profileInput`}
                        placeholder="Date"
                        defaultValue={"0"}
                        value={year}
                        onChange={(e) => setYear(e.target?.value)}
                    >
                        <MenuItem selected value="0">All</MenuItem>
                        <MenuItem value="1">Last Month</MenuItem>
                        <MenuItem value="2">6 Months</MenuItem>
                        <MenuItem value="3">1 Year</MenuItem>
                    </Select>
                </FormGroup>
            </div>
            {
                loading ? <Loader />
                    :
                    <TableContainer component={Paper} className='TableContainer'>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead className='custumTableHead'>
                                <TableRow className={styles.completeTableRow}>
                                    <TableCell>Patient Name</TableCell>
                                    <TableCell align="right">Phone</TableCell>
                                    <TableCell align="right">Date</TableCell>
                                    <TableCell align="right">Notes</TableCell>
                                    <TableCell align="right"></TableCell>
                                    {/* <TableCell align="right"></TableCell> */}
                                </TableRow>
                            </TableHead>
                            {
                                labTestData?.length > 0 ?
                                    <TableBody>
                                        {
                                            labTestData?.map((item, index) => {
                                                return (
                                                    <TableRow
                                                        key={index}
                                                        className='custumTableRow cursor-pointer'
                                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                    >
                                                        <TableCell component="th" scope="row">
                                                            {item?.patientName}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {item?.phone}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {item?.createdAt}
                                                        </TableCell>
                                                        <TableCell component="th" scope="row">
                                                            {item?.notes}
                                                        </TableCell>
                                                        {
                                                            item?.prescriptionFile &&
                                                            <TableCell component="th" scope="row">
                                                                <div className='flex justify-center items-center'>
                                                                    <button className={`outLineBtn ${styles.downloadPresBtn}`} onClick={(e) => item?.prescriptionFile && handleViewReport(e, item?.prescriptionFile)}>View</button>
                                                                </div>
                                                            </TableCell>
                                                        }

                                                        {/* <TableCell >
                                                            <FormGroup className="customFormGroup w-36">
                                                                <Select
                                                                    className={`custumTextField profileInput`}
                                                                    placeholder="Date"
                                                                    defaultValue={"0"}
                                                                    value={actionValues[index] || '0'}
                                                                    onChange={(event) => handleAction(event, index, item)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    <MenuItem selected value="0">No Action</MenuItem>
                                                                    <MenuItem value="Approve">Approve</MenuItem>
                                                                    <MenuItem value="Cancel">Cancel</MenuItem>
                                                                </Select>
                                                            </FormGroup>
                                                        </TableCell> */}
                                                    </TableRow>
                                                )
                                            })
                                        }
                                    </TableBody>
                                    :
                                    <TableBody>
                                        <TableRow
                                            className='custumTableRow'
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row" colSpan={5}>
                                                <NoDataFound />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                            }
                        </Table>
                    </TableContainer>
            }


            {/* <ConfirmModal
                openConfirmModal={openConfirmModal}
                CloseConfirmModal={CloseConfirmModal}
                confirmSubmit={confirmSubmit}
                btnLoading={btnLoading}
                title={`Are you sure you want to ${actionValues[particularData ? labTestData.indexOf(particularData) : -1]} this lab test?`}
            /> */}
        </div>
    );
}